import { render, staticRenderFns } from "./childEditor.vue?vue&type=template&id=7784f4d8&scoped=true"
import script from "./childEditor.vue?vue&type=script&lang=js"
export * from "./childEditor.vue?vue&type=script&lang=js"
import style0 from "./childEditor.vue?vue&type=style&index=0&id=7784f4d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7784f4d8",
  null
  
)

export default component.exports